import { render, staticRenderFns } from "./SensorListItem.vue?vue&type=template&id=2b7a38d2&scoped=true&lang=pug"
import script from "./SensorListItem.vue?vue&type=script&lang=ts"
export * from "./SensorListItem.vue?vue&type=script&lang=ts"
import style0 from "./SensorListItem.vue?vue&type=style&index=0&id=2b7a38d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b7a38d2",
  null
  
)

export default component.exports